var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubAiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.588 9.218c1.244 4.474-.191 9.115-4.186 12.56-3.995 3.468-10.55 5.741-14.976 3.014C1.001 22.089-1.296 14.338.761 8.74 2.82 3.118 9.231-.375 14.35.032c5.143.407 9.018 4.737 10.238 9.186z",
    fill: "#383D4A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sub_ai_icon_svg__clip0_326_1053)",
    fill: "#B8EF36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.472 9.597h1.67v9.635h-1.67v-1.658c-.832 1.272-2.043 1.91-3.63 1.91-1.344 0-2.492-.493-3.44-1.475-.947-.982-1.421-2.18-1.421-3.593 0-1.413.474-2.611 1.422-3.595.947-.982 2.095-1.475 3.439-1.475 1.587 0 2.798.637 3.63 1.91V9.596zm-3.418 8.27c.973 0 1.786-.332 2.439-.994.652-.663.979-1.481.979-2.457 0-.976-.327-1.797-.98-2.457-.652-.663-1.467-.994-2.438-.994-.971 0-1.768.331-2.42.994-.653.662-.98 1.482-.98 2.457 0 .974.325 1.796.98 2.457.652.662 1.46.993 2.42.993zM17.923 8.748c-.32 0-.589-.11-.806-.327a1.07 1.07 0 01-.326-.79c0-.307.108-.574.326-.8.217-.224.485-.337.806-.337.32 0 .569.113.786.337.22.226.326.49.326.8 0 .31-.108.571-.326.79-.217.22-.48.327-.786.327zM18.748 9.597h-1.67v9.635h1.67V9.597z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sub_ai_icon_svg__clip0_326_1053"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5.981 6.494)",
    d: "M0 0h13.055v12.99H0z"
  })))));
}
export default SvgSubAiIcon;